<template>
  <modal :show="show" header-classes="justify-content-center" @close="handleClose()">
    <h4>
      Bible study occurred on:
    </h4>

    <div
      :class="{
        validationErrorText: validationErrors.metOnDateError,
        noError: !validationErrors.metOnDateError
      }"
    >
      <datepicker
        class="datepicker"
        placeholder="Select Date"
        v-model="metOnDate"
        :disabled-dates="invalidDates"
      />
    </div>
    <p
      v-show="validationErrors.metOnDateError"
      :class="{
        validationErrorText: validationErrors.metOnDateError
      }"
    >
      {{ validationErrors.metOnDateError }}
    </p>

    <BSA
      ref="childBSAComponent"
      :attendance="bibleStudyAttendance"
      :title="null"
      :can-cancel="false"
      :show-met-at="false"
      :is-embedded-in-modal="true"
      @returnBSAData="saveBSA($event)"
    />
  </modal>
</template>

<script>
import {
    mapState, mapGetters, vuex
} from 'vuex';
import Datepicker from 'vuejs-datepicker';
import modal from '../../UIComponents/Modal';
import BSA from './Attendance';

export default {
    name: 'CreateBSAModal',
    components: {
        modal,
        Datepicker,
        BSA
    },
    data() {
        return {
            namespace: 'BibleStudies',
            metOnDate: null,
            invalidDates: {
                from: new Date(Date.now()),
                to: new Date(this.bibleStudy.start_date)
            },
            validationErrors: {
                metOnDateError: '',
            }
        };
    },
    props: {
        show: Boolean,
        bibleStudy: Object,
    },
    computed: {
        ...mapState({
            error: (state) => state.BibleStudies.error,
            bibleStudyAttendance: (state) => state.BibleStudies.bibleStudyAttendance
        })
    },
    methods: {
        saveBSA(BSAData) {
            switch (this.metOnDate === null) {
            case true:
                this.validationErrors.metOnDateError = 'Please select a date.';
                break;
            default:
                BSAData.met_on_date = this.transformJSDateForPayload(this.metOnDate);
                this.$store.dispatch(`${this.namespace}/storeBibleStudyAttendance`, {
                    bibleStudyId: this.bibleStudy.id,
                    attendance_data: BSAData,
                }).then(
                    this.handleClose()
                );
            }
        },
        handleClose() {
            this.metOnDate = null;
            this.validationErrors.metOnDateError = '';
            this.$refs.childBSAComponent.participantsAttended = [];
            this.$emit('close');
        },
    },
};
</script>
<style>
</style>
